import { useCallback, useState } from 'react';
import ApprovalsService from '../services/ApprovalsService';
import { errorText } from '../utils/format';
import useAsync from './useAsync';

export function useApprovalsViewModel(filter) {
  const load = useCallback(() => ApprovalsService.list(filter === 'all' ? undefined : filter), [filter]);
  const { data, loading, error, reload } = useAsync(load);
  const [busyId, setBusyId] = useState('');
  const [feedback, setFeedback] = useState(null);

  const decide = async (id, action, grants) => {
    setBusyId(id);
    setFeedback(null);
    try {
      if (action === 'approve') await ApprovalsService.approve(id, grants);
      else await ApprovalsService.reject(id);
      setFeedback({
        severity: 'success',
        text: action === 'approve'
          ? 'Approved.'
          : 'Rejected. Nothing was sent.',
      });
    } catch (err) {
      setFeedback({ severity: 'error', text: errorText(err) });
    } finally {
      setBusyId('');
      reload({ silent: true });
    }
  };

  return {
    approvals: data || [],
    loading,
    error,
    reload,
    busyId,
    feedback,
    clearFeedback: () => setFeedback(null),
    approve: (id, grants) => decide(id, 'approve', grants),
    reject: (id) => decide(id, 'reject'),
  };
}
